import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Avatar, Button, Card, Divider, Row, Text } from "@nextui-org/react";
import classNames from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import { env } from "resume-builder-v2-common";
import { SessionContext } from "../context/session-context";
import { Icon } from "./fa-icon";
import { Link } from "./link";
import styles from "./user-tile.module.less";

var signOut = function signOut() {
  location.href = "".concat(env.api, "/logout");
};

var signIn = function signIn() {
  location.href = "".concat(env.api, "/login");
};

export var UserTile = function UserTile() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showMenu = _useState2[0],
      setShowMenu = _useState2[1];

  var toggleShowMenu = useCallback(function () {
    setShowMenu(function (v) {
      return !v;
    });
  }, []);
  useEffect(function () {
    if (!showMenu) return;

    var handleClick = function handleClick() {
      setShowMenu(false);
    };

    document.body.addEventListener("click", handleClick);
    return function () {
      document.body.removeEventListener("click", handleClick);
    };
  }, [showMenu]);
  return /*#__PURE__*/React.createElement(SessionContext.Consumer, null, function (sessionUser) {
    var isSignedIn = !!sessionUser;

    var avatarProps = _objectSpread(_objectSpread(_objectSpread({}, !isSignedIn && {
      text: "Sign in",
      icon: /*#__PURE__*/React.createElement(Icon, {
        name: "user"
      })
    }), isSignedIn && sessionUser.photoUrl && {
      alt: sessionUser.displayName,
      src: sessionUser.photoUrl
    }), isSignedIn && !sessionUser.photoUrl && {
      text: sessionUser.displayName
    });

    var cardHeader = isSignedIn ? sessionUser.displayName : "Not signed in";
    var cardColor = isSignedIn ? "gradient" : "warning";
    var cardBody = isSignedIn ? /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("ul", {
      className: styles.navList
    }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
      to: "/",
      color: "text"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "home"
    }), " Home")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
      to: "/my-account",
      color: "text"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "user"
    }), " My Account")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
      to: "/interactive",
      color: "text"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "file-lines"
    }), " Resume Editor")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
      to: "/resumes",
      color: "text"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "clipboard-list"
    }), " Resume Manager")))) : /*#__PURE__*/React.createElement(Text, null, "You must be signed in to use features");
    var action = isSignedIn ? /*#__PURE__*/React.createElement(Button, {
      onClick: signOut,
      size: "sm",
      flat: true
    }, "Sign out") : /*#__PURE__*/React.createElement(Button, {
      onClick: signIn,
      size: "sm",
      flat: true,
      color: "warning"
    }, "Sign in");
    var menu = /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.userTileWrapper, showMenu && styles.show)
    }, /*#__PURE__*/React.createElement(Card, {
      color: cardColor,
      bordered: true
    }, /*#__PURE__*/React.createElement(Card.Header, null, cardHeader), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Card.Body, null, cardBody), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Row, {
      justify: "flex-end"
    }, action))));
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: "relative"
      }
    }, /*#__PURE__*/React.createElement(Avatar, _extends({}, avatarProps, {
      squared: true,
      pointer: true,
      bordered: true,
      color: "gradient",
      size: "lg",
      onClick: toggleShowMenu
    })), menu);
  });
};